var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[(_vm.active)?_c('b-badge',{attrs:{"pill":"","variant":_vm.badgeVariant}},[_vm._v("Active")]):_c('b-badge',{attrs:{"pill":"","variant":_vm.badgeVariant}},[_vm._v("Inactive")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }